import React, { useContext, useEffect, useState, Suspense, lazy } from "react";
import { FormControlLabel, Switch, Tooltip } from "@mui/material";
import { QuoteContext } from "./QuoteContext";
import ApiService from "../../services/ApiService"; // Import API service
import { motion } from "framer-motion";
import { DotLoaderComp } from '../../components/DotLoader/index';
import CustomTooltip from "../../components/ToolTip";

const CardSection = lazy(() => import("./CardSection"));

const Plans = () => {
  const { formValues, updateFormValues, nextStep, prevStep } = useContext(QuoteContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [aseanCover, setAseanCover] = useState(formValues.aseanCover || "no");
  const [outpatient, setOutpatient] = useState(formValues.outpatient || "no");
  const [plans, setPlans] = useState(formValues.plans || []);
  const [selectedPlans, setSelectedPlans] = useState(
    formValues.selectedPlans || []
  );

    // List of country IDs that allow ASEAN Cover
    const aseanCountryIds = ["37", "102", "120", "133", "151", "175", "214", "217", "238"];
  
    // Check if the residency is eligible for ASEAN Cover
    const isAseanEligible = aseanCountryIds.includes(formValues.residency.id);

  useEffect(() => {
    if (!formValues.ages || !formValues.residency) {
      setError("Missing required data. Please complete previous steps.");
      setLoading(false);
      return;
    }
    // if (!formValues.aseanCover || !formValues.outpatient) {
    //     updateFormValues({
    //       aseanCover: formValues.aseanCover || "no", // Default to "no" if not set
    //       outpatient: formValues.outpatient || "no", // Default to "no" if not set
    //     });
    // }

    const fetchPlans = async () => {
      setLoading(true);
      setError("");
      const payload = {
        members: formValues.ages.map((age) => Number(age)), // Convert ages to numbers
        residency: formValues.residency.id,
        // asean_cover: aseanCover, // Now storing "yes" or "no"
        // outpatient: outpatient,  // Now storing "yes" or "no"
      };

      console.log("API Request Payload:", payload);

      try {
        const data = await ApiService.handleGetAllPlans(payload); 
        setPlans(data.data || []);
        updateFormValues({ plans: data.data || [] });
      } catch (err) {
        console.error("API Error:", err);
        setError("Failed to fetch plans. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, []); // Reload API when toggles change

  const handleToggleChange = (type) => {
    // Clear selected plans both locally
    setSelectedPlans([]);
    if (type === "asean") {
      const newAseanValue = aseanCover === "yes" ? "no" : "yes"; // Flip between "yes" and "no"
      setAseanCover(newAseanValue);
      console.log("Updated ASEAN Cover in Context:", newAseanValue);
    } else {
      const newOutpatientValue = outpatient === "yes" ? "no" : "yes"; // Flip between "yes" and "no"
      setOutpatient(newOutpatientValue);
      console.log("Updated Outpatient Exclusion in Context:", newOutpatientValue);
    }
  };

  // Sync local state updates (toggles and selectedPlans) to context after render
  useEffect(() => {
    updateFormValues({
      aseanCover,
      outpatient,
      selectedPlans: [],
    });
  }, [aseanCover, outpatient]);

  useEffect(() => {
    let filteredPlans = formValues.plans || [];

    if (aseanCover === "yes") {
      filteredPlans = filteredPlans.filter((plan) => plan.area_id === 4 || plan.area_id === 5);
    }

    if (outpatient === "yes") {
      filteredPlans = filteredPlans.filter((plan) => plan.plan_type === "inpatient");
    } else {
      filteredPlans = filteredPlans.filter((plan) => plan.plan_type === "outpatient");
    }

    setPlans(filteredPlans);
  }, [aseanCover, outpatient, formValues.plans]);

  const handlePlanSelection = (selectedCards) => {

    setSelectedPlans(selectedCards);
    // updateFormValues({ selectedPlans: selectedCards }); // Ensure persistence
  };


  const handleContinue = () => {
    if (selectedPlans.length === 0) {
      alert("Please select at least one plan to continue.");
      return;
    }
    nextStep();
  };

  useEffect(() => {
    updateFormValues({ selectedPlans });
  }, [selectedPlans]);
  


//   // Sync selected plans from context
//   useEffect(() => {
//     setSelectedPlans(formValues.selectedPlans || []);
//   }, [formValues.selectedPlans]);

  return (
    <div className="flex flex-col items-center justify-center h-full ">
      {/* <h2 className="text-orangeColor text-2xl">Available Plans</h2> */}

      {/* Toggle Switches */}
      <div className=" flex flex-col md:flex-row  sm:py-[6.4px] justify-between sm:px-5 md:px-10 w-full  z-50 bg-[#0C3C5F] fixed md:sticky bottom-0 md:top-[19px]">
      <div className="flex justify-between md:justify-normal">
     {/* ASEAN Cover (Only Show if Residency Matches) */}
     {isAseanEligible && (
            <div className="gap-2 flex items-center ">
              <CustomTooltip title="ASEAN Cover: Coverage for ASEAN regions" arrow >
                <span className="ml-2 text-[12px] sm:text-sm cursor-pointer text-white">
                  ASEAN Cover ℹ️
                </span>
              </CustomTooltip>
              <FormControlLabel
                control={
                  <Switch
                    checked={aseanCover === "yes"}
                    onChange={() => handleToggleChange("asean")}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#F79029", // Orange color
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                        backgroundColor: "#F79029", // Orange color
                      },
                    }}
                  />
                }
                label=""
              />
            </div>
          )}

          <div className=" flex items-center justify-between gap-2">
            <Tooltip title="Outpatient Exclusion: Excludes outpatient coverage" arrow>
              <span className="ml-2 text-[12px] sm:text-sm cursor-pointer text-white">
                Outpatient Exclusion
              </span>
            </Tooltip>
            <FormControlLabel
            
              control={
                <Switch
                 
                  checked={outpatient === "yes"}
                  onChange={() => handleToggleChange("outpatient")}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#F79029", // Orange color
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#F79029", // Orange color
                    },
                    "& .MuiSwitch-thumb": {
          
        },
                  }}
                />
              }
              label=""
            />
          </div>
        </div>
        <div className="mx-1">
          {/* <button className="bg-gray-500 text-white px-5 py-2 rounded hover:bg-gray-700" onClick={prevStep}>
          Back
        </button> */}
          {/* <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleContinue}
            className="bg-orangeColor text-white py-2 sm:py-3 px-4 sm:px-6 rounded-xl w-full hover:bg-[#ff9800] transition-all max-sm:fixed max-sm:bottom-16 max-sm:right-0 max-sm:w-auto max-sm:py-3 max-sm:rounded-l-full"
          >
            Continue →
          </motion.button> */}
          <motion.button
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
  animate={{
    scale: [1, 1.02, 1], // Creates a pulsing effect
    opacity: [1, 0.8, 1], // Slight fade effect
  }}
  transition={{
    duration: 1.5, // Animation duration
    repeat: Infinity, // Infinite loop
  }}
  onClick={handleContinue}
  className="bg-orangeColor text-white py-2 sm:py-3 px-4 sm:px-6 rounded-xl w-full hover:bg-[#ff9800] 
             transition-all max-sm:fixed max-sm:bottom-16 max-sm:right-0 max-sm:w-auto max-sm:py-3 
             max-sm:rounded-l-full"
>
  Continue →
</motion.button>

        </div>
      </div>

      {/* Plan Cards Section */}
      <div className="flex flex-col space-y-4">
      {loading ? (
        <div className=" mt-4">

       <DotLoaderComp/>
        </div>
      ) : (
        <Suspense fallback={<div className="h-[500px] w-[52%]"></div>}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5 }}
          >
            <CardSection
              selectedPlans={selectedPlans}
              setSelectedPlans={handlePlanSelection}
              plans={plans}
              setPlans={setPlans}
            />
          </motion.div>
        </Suspense>
      )}
</div>
    </div>
  );
};

export default Plans;
